import { Navigation, NavigationBar, NavigationButton, NavigationCustomMenu, NavigationLink, NavigationMenu, NavigationMenuList } from '@hub/navigation';
import { Stack } from '@hub/stack';
import React from 'react';
import { isDefinedAndNotNull } from '../../../lib';
import { useIsRouteChanging } from '../../../next/router';
import MegaMenu from '../../mega-menu';
import { isNavigationLink, isNavigationMegaMenu, isNavigationSimpleMenu } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavigationBarChildMegaMenu = _ref => {
  let {
    item,
    onClickLink
  } = _ref;
  return /*#__PURE__*/_jsxs(NavigationCustomMenu, {
    "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationCustomMenu",
    children: [/*#__PURE__*/_jsx(NavigationButton, {
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationCustomMenu_NavigationButton",
      children: item.title
    }), OverlayContentBox => /*#__PURE__*/_jsx(OverlayContentBox, {
      backgroundColor: "surfaceBrandPrimary",
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_OverlayContentBox",
      children: /*#__PURE__*/_jsx(MegaMenu, {
        items: item.items,
        feature: item.feature,
        onClickFeature: event => {
          var _item$feature$title;
          return item.feature.link && (onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [item, {
            label: (_item$feature$title = item.feature.title) !== null && _item$feature$title !== void 0 ? _item$feature$title : item.feature.link.label,
            url: item.feature.link.url
          }]));
        },
        onClickLink: (event, path) => path.length === 2 && ( // megamenu columns titles aren't tracked (to match legacy behaviour)
        onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [item, ...path])),
        "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_OverlayContentBox_MegaMenu"
      })
    })]
  });
};
const NavigationBarChildSimpleMenu = _ref2 => {
  let {
    item,
    onClickLink
  } = _ref2;
  return /*#__PURE__*/_jsxs(NavigationMenu, {
    "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationMenu",
    children: [/*#__PURE__*/_jsx(NavigationButton, {
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationMenu_NavigationButton",
      children: item.title
    }), /*#__PURE__*/_jsx(NavigationMenuList, {
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationMenu_NavigationMenuList",
      children: item.items.map((subItem, key) => isNavigationLink(subItem) && /*#__PURE__*/_jsx(NavigationLink, {
        href: subItem.url,
        onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [item, subItem]),
        "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationLink",
        children: subItem.label
      }, key))
    })]
  });
};
const NavigationBarChild = _ref3 => {
  let {
    item,
    onClickLink
  } = _ref3;
  if (isNavigationMegaMenu(item)) {
    return /*#__PURE__*/_jsx(NavigationBarChildMegaMenu, {
      item: item,
      onClickLink: onClickLink,
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu"
    });
  } else if (isNavigationSimpleMenu(item)) {
    return /*#__PURE__*/_jsx(NavigationBarChildSimpleMenu, {
      item: item,
      onClickLink: onClickLink,
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationBarChildSimpleMenu"
    });
  } else if (isNavigationLink(item)) {
    return /*#__PURE__*/_jsx(NavigationLink, {
      href: item.url,
      onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [item]),
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationLink",
      children: item.label
    });
  }
  return null;
};
export const HeaderNavigation = _ref4 => {
  let {
    trigger = ['click', null, 'hover'],
    fadeDuration,
    isOpen,
    primaryItems,
    secondaryItems,
    onOpen,
    onClose,
    onClickLink
  } = _ref4;
  const isRouteChanging = useIsRouteChanging();
  return /*#__PURE__*/_jsx(Navigation, {
    allowOpen: !isRouteChanging,
    trigger: trigger,
    fadeDuration: fadeDuration,
    isOpen: isOpen,
    onClose: onClose,
    onOpen: onOpen,
    backgroundColor: "surfaceBrandPrimary",
    "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_Navigation",
    children: /*#__PURE__*/_jsx(Stack, {
      direction: "row",
      justify: "space-between",
      "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_Navigation_Stack",
      children: [primaryItems, secondaryItems].filter(isDefinedAndNotNull).map((items, key) => /*#__PURE__*/_jsx(NavigationBar, {
        "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationBar",
        children: items.map((item, key) => /*#__PURE__*/_jsx(NavigationBarChild, {
          item: item,
          onClickLink: onClickLink,
          "data-id": "header-navigation-bar_navigation_NavigationBarChildMegaMenu_NavigationBarChild"
        }, key))
      }, key))
    })
  });
};